import _ from 'lodash';



const isFiltered = (state) =>{
  // return !(state.filters.active == true &&
  //         state.filters.checkedCustomerTypes.length==0 &&
  //         state.filters.checkedCustomerClasses.length==0 &&
  //         state.filters.checkedTags.length==0 &&
  //         state.search==='' &&
  //         state.filters.checkedReps.length==0 &&
  //         state.filters.checkedTerritories.length==0 &&
  //         state.filters.withoutTerritories==false &&
  //         state.filters.withoutReps==false)
  //
  return !(state.search==='')

}

function getCreditUsed(creditNote){
  let creditUsed = 0.00;
  _.forEach(creditNote.invoices, i=>{
    creditUsed+=i.amount;
  })
  return creditUsed
}

const creditAppliedTo = (state) => (creditNote) =>{
  return str_invoices = "";
  _.forEach(creditNote.invoices, (i, index)=>{
    if(index>0){str_invoices+=', '}
    str_invoices+=i.inv_number;
  })
  return str_invoices;
}

const creditUsed = (state) => (creditNote) =>{
  return getCreditUsed(creditNote);
}
const creditBalance = (state) => (creditNote) =>{
  return (creditNote.total - getCreditUsed(creditNote))
}

const getOrderBy = (state) =>{
  return state.orderBy;
}

const getSortIcon = (state) =>{
  return state.sort_icon;
}
/**
 * Fonction permettant de retourner la balance d'un tableau
 * de Notes de crédit. La note de crédit doit un status.code
 * @param  {[type]} state [description]
 * @return {[type]}       [description]
 */
const getCreditBalance = (state)=> (creditNotes) =>{
  let total = 0.00;
  _.forEach(creditNotes, c=>{

    if(c.status.code=='INIT' || c.status.code=='PARTIALLY_PAID'){
      total += c.total;
      _.forEach(c.invoices, i=>{
        total -= i.amount;
      })
    }
  })
  return total;
}

export default {
  creditUsed,
  creditBalance,
  isFiltered,
  getOrderBy,
  getSortIcon,
  creditAppliedTo,
  getCreditBalance
};
